import { Component, OnInit } from '@angular/core';
import { ClientesService } from 'src/app/services/clientes.service';
import { GruposService } from 'src/app/services/grupos.service';
import { LoginService } from 'src/app/services/login.service';

@Component({
  selector: 'app-reporte-grupos',
  templateUrl: './reporte-grupos.component.html',
  styleUrls: ['./reporte-grupos.component.scss']
})
export class ReporteGruposComponent implements OnInit {
  formulario;
  i = 0;
  grupos;   
  registros;

  respuestGrupos:any;

  fecha_inicio;
  fecha_fin;
  data;
  respuesta:any;

  constructor(private _getGrupos: GruposService, private _get:ClientesService, private _getData:LoginService,) { }

  ngOnInit(): void {
    this.formulario = {
      'fecha_inicio':'',
      'fecha_fin':'',
    }
  }

  getRegistrosPorGrupo(){
    if (this.formulario.fecha_inicio != null){
      this.fecha_inicio = this.formulario.fecha_inicio['year']+'-'+this.formulario.fecha_inicio['month']+'-'+this.formulario.fecha_inicio['day']
    }

    if (this.formulario.fecha_fin != null){
      this.fecha_fin = this.formulario.fecha_fin['year']+'-'+this.formulario.fecha_fin['month']+'-'+this.formulario.fecha_fin['day']
    }


    this.data = {
      'fecha_fin':this.fecha_fin,
      'fecha_inicio':this.fecha_inicio,
    }


    this._get.getRegistrosPorGrupo(this.data).subscribe(
      data => {
        this.respuesta = data;
        if(this.respuesta.success){
          this.registros = this.respuesta.registros;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }
} 
